import React from "react";
import * as ReactDOM from "react-dom/client";
import "./index.css";
import Router from "./Router";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import { BrowserRouter } from "react-router-dom";
import store from "./redux/store";
import "./font/Font.css";
import {createTheme , ThemeProvider} from "@mui/material";

const theme = createTheme({
  typography: {
    fontFamily: "Gmarket"
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Times New Roman';
          src: local('Times New Roman');
        }

        /* 베트남어 텍스트에만 Times New Roman 폰트 적용 */
        [lang="vi"] {
          font-family: 'Times New Roman', serif;
        }
      `,
    },
  },
})


const persistor = persistStore(store);

const rootElment = document.getElementById("root");
if (!rootElment) throw new Error("Failed to find the root element");
const root = ReactDOM.createRoot(rootElment);
root.render(
    <Provider store={store} >
      <ThemeProvider theme={theme}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <Router />
          </BrowserRouter>
        </PersistGate>
      </ThemeProvider>
    </Provider>
);
